import History from "../@history";
import { decryptData } from "../services/dashboard-service/encryptionService";

export const validateUserData = (navigate) => {
    const tokenData = localStorage.getItem("userData");

    if (tokenData) {
        try {
            // Decrypt the token data
            const decryptedData = decryptData(tokenData);

            if (decryptedData) {
                const parsedData = JSON.parse(decryptedData);

                // Check if parsedData is valid
                if (parsedData) {
                    const user = parsedData
                    // if ((user && user?.Is_FirstPasswordChanged === 0) || (user && user?.isOtpVerified === 0)) {
                    if (user && user?.Is_FirstPasswordChanged === 0) {
                        localStorage.removeItem('userData');
                        History.push("/login")
                        return null;
                    }
                    return parsedData; // Return the user data if valid
                } else {
                    throw new Error('Invalid data format');
                }
            } else {
                throw new Error('Failed to decrypt data');
            }
        } catch (error) {
            // Log the error, clear localStorage and redirect to login
            console.error("Error parsing user data:", error);
            localStorage.removeItem('userData');
            History.push('/login');
            return null;
        }
    } else {
        // If no tokenData exists in localStorage, redirect to login
        History.push('/login');
        return null;
    }
}

